<template>
  <div class="tip-page flex">
    <side-menu />
    <div class="lg:pl-16 flex-grow w-full">
      <NavBar title="Tip" />
      <Loader v-if="loading" />
      <div
        v-else-if="!game"
        class="flex flex-col m-4 w-full md:w-6/12 items-stretch justify-between text-center bg-white dark:bg-bs-dark-bg-over rounded-3xl mb-4 tip-item p-5"
      >
        <font-awesome-icon
          :icon="'times-circle'"
          class="text-red-600 mx-auto mt-8"
          size="3x"
        />
        <h2 class="font-bold text-2xl text-bs-dark-bg dark:text-white mt-4 mb-8">
          Tip does not exist
        </h2>
      </div>
      <div
        v-else
        class="flex flex-col md:px-8 2xl:px-12 py-8 md:items-stretch justify-center"
      >
        <div class="flex md:flex-row md:items-start justify-center">
          <!--MOBILE -->
          <div class="md:hidden flex flex-col w-full px-4 space-y-8 mb-12 md:mb-0">
            <tip-item v-bind="game" v-if="game" class="flex-1" :skipH2H="true" />
            <tip-impact-card v-if="game && isSettled" v-bind="game" />
            <what-to-tip :game="game" />
            <h-2-h
              class="h2h flex-1"
              v-if="game.preGameStats"
              :homeData="game.preGameStats.homeData"
              :awayData="game.preGameStats.awayData"
            />
            <live-data v-bind="liveData" v-if="liveData" />
            <tip-match-radar
              v-if="game && game.gameMoment"
              :gameMoment="game.gameMoment"
              :homeTeam="game.homeTeam"
              :awayTeam="game.awayTeam"
            />
            <tip-match-dynamics
              v-if="game && game.gameMoment"
              :gameMoment="game.gameMoment"
              :algorithm="game.algorithm"
              :homeTeam="game.homeTeam"
              :awayTeam="game.awayTeam"
              :homeGoals="game.homeGoals"
              :awayGoals="game.awayGoals"
              :minute="game.minute"
              :confidence="game.confidence"
            />
          </div>

          <!-- WEB -->
          <div class="hidden md:flex flex-col w-6/12 xl:w-4/12 mr-8 ">
            <tip-item v-bind="game" v-if="game" class="flex-1" :skipH2H="true" />
            <tip-impact-card v-if="game && isSettled" v-bind="game" />
            <live-data v-bind="liveData" v-if="liveData"  class="mb-auto"/>
          </div>
          <div class="hidden md:flex flex-col w-6/12 xl:w-4/12">
            <what-to-tip :game="game" />
            <tip-match-radar
              v-if="game && game.gameMoment"
              :gameMoment="game.gameMoment"
              :homeTeam="game.homeTeam"
              :awayTeam="game.awayTeam"
            />
            <!--head t head -->
              <div v-if="game.preGameStats" class="bg-white dark:bg-bs-dark-bg-over rounded-3xl tip-item p-3 flex-1 mt-8">
                <h-2-h
                  class="h2h"
                  :homeData="game.preGameStats.homeData"
                  :awayData="game.preGameStats.awayData"
                />
              </div>
          </div>
        </div>

        <!-- WIDE WIDGET — width-matched to the column row above -->
        <div class="hidden md:flex justify-center mt-4">
          <div class="w-full xl:w-8/12">
            <tip-match-dynamics
              v-if="game && game.gameMoment"
              :gameMoment="game.gameMoment"
              :algorithm="game.algorithm"
              :homeTeam="game.homeTeam"
              :awayTeam="game.awayTeam"
              :homeGoals="game.homeGoals"
              :awayGoals="game.awayGoals"
              :minute="game.minute"
              :confidence="game.confidence"
            />
          </div>
        </div>
      </div>
    </div>
    <mob-menu class="lg:hidden" />
  </div>
</template>

<script>
import SideMenu from "@/components/organisms/SideMenu.vue";
import NavBar from "@/components/organisms/NavBar.vue";
import { mapActions, mapGetters } from "vuex";
import format from "date-fns/esm/format/index";
import TipItem from "@/components/atoms/TipItem.vue";
import TipImpactCard from "@/components/atoms/TipImpactCard.vue";
import TipMatchDynamics from "@/components/atoms/TipMatchDynamics.vue";
import TipMatchRadar from "@/components/atoms/TipMatchRadar.vue";
import H2H from "@/components/atoms/H2H.vue";
import WhatToTip from "../../atoms/WhatToTip.vue";
import MobMenu from "@/components/organisms/MobMenu.vue";
import LiveData from "../../atoms/LiveData.vue"
export default {
  components: {
    NavBar,
    SideMenu,
    TipItem,
    TipImpactCard,
    TipMatchDynamics,
    TipMatchRadar,
    H2H,
    WhatToTip,
    LiveData,
    MobMenu
  },
  data: function () {
    return {
      loading: false,
      
    };
  },
  mounted: async function () {
    if (!this.tips?.length) {
      this.loading = true;
      await this.getData();
      this.loading = false;
    }
    // await Socket().addEventListener('message',  this.onLiveData);
  },
  unmounted: async function(){
    // await Socket().removeEventListener('message',  this.onLiveData);
  },
  computed: {
    ...mapGetters(["tips", "settings", "getLiveData"]),
    currency: function () {
      return this?.settings?.currencyCode || "€";
    },
    game: function () {
      let tip = this.tips.find((tip) => tip.id === this.$route.params.id);
      if (tip) {
        let { status: statusLabel, class: statusClass } = this.getStatus(tip.status);
        return {
          ...tip,
          formattedDate: this.formatDate(tip.createdDate),
          statusLabel,
          statusClass,
        };
      } else {
        return undefined;
      }
    },
    liveData: function() {
      return this?.game?.eventId && this.getLiveData(this.game.eventId)
    },
    isSettled: function() {
      return this.game && this.game.status !== "PENDING" && this.game.status !== 0 && this.game.status !== "0";
    }
  },
  methods: {
    ...mapActions({
      getSettings: "getSettings",
      getHistory: "getHistory",
      getSummary: "getSummary",
    }),
    
    getData: async function () {
      await this.getHistory();
      await this.getSummary();
      await this.getSettings();
    },
    formatDate: function (str) {
      try {
        let d = new Date(str);
        if (d) {
          return format(d, "dd-MM-yyyy");
        }
      } catch (e) {
        console.log(e);
      }
    },
    getStatus: function (status) {
      switch (status) {
        case 0:
        case "0":
        case "PENDING":
          return {
            status: "Pending",
            class: "is-pending",
          };
        case 1:
        case "1":
        case "SUCCESS":
          return {
            status: "Success",
            class: "is-win",
          };
        case 2:
        case "2":
        case "FAIL":
          return {
            status: "Fail",
            class: "is-loss",
          };
        case 3:
        case "3":
        case "VOID":
          return {
            status: "Void",
            class: "is-void",
          };

        case 4:
        case "4":
        case "HALFWIN":
          return {
            status: "Half Win",
            class: "is-half-win",
          };
        case 5:
        case "5":
        case "HALFLOSS":
          return {
            status: "Half Loss",
            class: "is-half-loss",
          };
      }
    },
  },
};
</script>

<style>
.tip-page {
  height:100vh;
}
</style>
